import {http_request} from "../../httpConfig";

export const products = {
    namespaced: true,
    state: {
        dataLoadFlag: false,
        selectedCategory: null,
        productsSelectedCategory: {},
        productsUsedInProject: {},
    },
    mutations: {
        DATA_LOAD_FLAG: function (state, value){
          state.dataLoadFlag = value;
        },
        SELECTED_CATEGORY: function (state, idCategory) {
            state.selectedCategory = idCategory;
        },
        PRODUCTS_SELECTED_CATEGORY: function (state, data) {
            const objProducts = {};
            for (let product of data) {
                objProducts[product.uuid] = product;
            }
            state.productsSelectedCategory = objProducts;           //  Чтобы vue отследило изменение products.
        },
        ARRAY_PRODUCTS_USED_IN_PROJECT: function (state, data) {
            const objProducts = {};
            for (let product of data) {
                state.productsUsedInProject[product.uuid] = product;
            }
        },
        PRODUCT_USED_IN_PROJECT: function (state, product) {
            state.productsUsedInProject[product.uuid] = product;
        },
        FILL_PRODUCT_USED_IN_PROJECT: function (state, arrUUID) {
            for (let productUUID of arrUUID) {
                if (!(productUUID in state.productsUsedInProject)) {
                    state.productsUsedInProject[productUUID] = null;
                }
            }
        }
    },
    getters: {
        PRODUCTS_SELECTED_CATEGORY: state => {
            return state.productsSelectedCategory;
        },
        CHECK_PRODUCTS: state => productsUUID => {
            for (let uuid of productsUUID) {
                if (!(uuid in state.productsUsedInProject) && !(uuid in state.productsSelectedCategory)) {
                    return false;
                }
            }
            return true;
        },
        PRODUCT_BY_UUID_ONLY_STORE: state => uuid => {
            if (uuid in state.productsUsedInProject) {
                return state.productsUsedInProject[uuid];
            }
            if (uuid in state.productsSelectedCategory) {
                return state.productsSelectedCategory[uuid];
            }
            return null;
        }
    },
    actions: {
        PRODUCT_CATEGORY_SELECTED: async function (context, idCategory) {
            if(idCategory === context.state.selectedCategory)
                return;

            context.commit('PRODUCTS_SELECTED_CATEGORY', []);
            context.commit('SELECTED_CATEGORY', idCategory);
            context.dispatch('GET_PRODUCTS_SELECTED_CATEGORY');
        },
        GET_PRODUCTS_SELECTED_CATEGORY: async function (context, category) {
            if(!context.state.selectedCategory){
                console.log('Не выбрана категория для загрузки продуктов.');
                return;
            }
            context.commit('DATA_LOAD_FLAG', true);
            await http_request.post('/get_products', {
                category: context.state.selectedCategory
            })
                .then((request) => {
                    console.log(request.data);
                    // context.commit('PRODUCTS_SELECTED_CATEGORY', request.data.products);
                    context.commit('PRODUCTS_SELECTED_CATEGORY', request.data.products);
                })
                .catch((error) => {
                    console.log(error);
                    console.log(error.response);
                });
            context.commit('DATA_LOAD_FLAG', false);
        },
        GET_PRODUCT_BY_UUID_FROM_SERVER: async function (context, uuid) {
            if (!uuid)
                return;

            let arrUUID;
            if (typeof uuid === "string") {
                arrUUID = [uuid];
            } else {
                arrUUID = uuid;
            }
            await http_request.post('/get_products', {
                uuid: arrUUID
            })
                .then((request) => {
                    console.log(request.data);
                    context.commit('ARRAY_PRODUCTS_USED_IN_PROJECT', request.data.products);
                    context.commit('FILL_PRODUCT_USED_IN_PROJECT', arrUUID);
                })
                .catch((error) => {
                    console.log(error);
                    console.log(error.response);
                });
        },
        PRODUCT_BY_UUID: async function (context, uuid) {
            if (uuid in context.state.productsUsedInProject)
                return context.state.productsUsedInProject[uuid];

            if (context.state.productsSelectedCategory[uuid]) {
                context.commit('PRODUCT_USED_IN_PROJECT', context.state.productsSelectedCategory[uuid]);
                return context.state.productsUsedInProject[uuid];
            }

            await context.dispatch('GET_PRODUCT_BY_UUID_FROM_SERVER', uuid);

            if (uuid in context.state.productsUsedInProject) {
                return context.state.productsUsedInProject[uuid];
            } else {
                return null;
            }
        }
    }
};
